import React, { useRef, Suspense } from 'react';
import { useInView } from 'framer-motion';

export const LazySection = ({ children, height = '100vh' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "200px" });

  return (
    <div ref={ref} style={{ minHeight: isInView ? 'auto' : height }}>
      {isInView && (
        <Suspense fallback={<div style={{ height }}></div>}>
          {children}
        </Suspense>
      )}
    </div>
  );
};
